import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import admin from "../../../services/adminService";
const Services = () => {
  const [ourService, setOurService] = useState([]);

  useEffect(() => {
    let ourService = admin.getOurServices();
    setOurService(ourService);
  }, []);

  return (
    <div className="container-fluid px-lg-3 py-2" id="services">
      <section className="pt-5">
        <div className="row">
          <div className="col-12">
            <h2 className="text-center font-weight-bold my-3 h1">
              Our services
            </h2>
          </div>

          <p className="text-center font-weight-bolder mb-5 w-responsive mx-auto">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugit,
            error amet numquam iure provident voluptate esse quasi, veritatis
            totam voluptas nostrum quisquam eum porro a pariatur veniam.
          </p>

          <div className="row text-center px-lg-3 text-md-left justify-content-center">
            {ourService.map((service) => (
              <div key={service.title} className="col-md-6 mb-4 text-center">
                <div className="card card-body rgba-white-slight text-left hoverable">
                  <p className="service-title font-weight-bold title font-weight-bold text-uppercase spacing mt-4 mx-4">
                    <i
                      className="fas fa-square orange-text mr-2"
                      aria-hidden="true"
                    ></i>
                    <strong className="orange-text">{service.title}</strong>
                  </p>
                  <p className="font-small mx-4 service-title">
                    {service.description}
                  </p>
                  <p className="font-small font-weight-bold orange-text mx-4 mb-0">
                    <Link to={service.href} className="orange-text">
                      read more
                    </Link>
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
